/*
 * Fila de tarjetas semáforo, réplica del .sem-card del HTML original (gradientes)
 */
import { Description, Heading } from "codekit";

import { bucketGradients, bucketLabels, fmtCOP } from "./utils/carthelp";

const SEGMENTS = ["verde", "amarillo", "rojo"];

/**
 * Renderiza las tres tarjetas semáforo de un grupo
 * @param {Object} props Propiedades del componente
 * @param {Object} props.groups Mapa { verde, amarillo, rojo } con { count, valor }
 * @param {Function} props.onCardClick Callback con el rango al hacer click
 */
const Semcards = ({ groups, onCardClick }) => {
  const bClickable = typeof onCardClick === "function";

  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 14, marginBottom: 16 }}>
      {SEGMENTS.map((sSeg) => (
        <div
          key={sSeg}
          onClick={bClickable ? () => onCardClick(sSeg) : undefined}
          style={{
            borderRadius: 14,
            padding: "16px 18px",
            color: "#fff",
            background: bucketGradients[sSeg],
            boxShadow: "0 2px 8px rgba(0,0,0,.08)",
            cursor: bClickable ? "pointer" : "default",
          }}
        >
          <div style={{ textTransform: "uppercase", letterSpacing: 0.5, opacity: 0.9 }}>
            <Description variant="description-4">{bucketLabels[sSeg]}</Description>
          </div>
          <div style={{ marginTop: 4 }}>
            <Heading variant="heading-5">{groups[sSeg].count} DO</Heading>
          </div>
          <div style={{ marginTop: 4, opacity: 0.95 }}>
            <Description variant="description-2">{fmtCOP(groups[sSeg].valor)}</Description>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Semcards;
